module.exports = __webpack_public_path__ + "img/HV.004f95bf.png";